// short-price.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortPrice'
})
export class ShortPricePipe implements PipeTransform {

  transform(value: number): string {
    if (value >= 1e6) {
      return (value / 1e6).toFixed(0) + 'M';  // For millions, no decimal
    } else if (value >= 1e3) {
      return (value / 1e3).toFixed(0) + 'K';  // For thousands, no decimal
    }
    return value.toString();  // Return the number as-is if it's less than 1,000
  }
}
